import { createContext, useContext } from 'react'
import type { FilterFieldsConfigContextValue } from './FilterFieldsConfigContext.types'

const defaultContextValue: FilterFieldsConfigContextValue = {
  elementUuid: '',
  uuidCurrentSitemodelObjectclass: ''
}

export const FilterFieldsConfigContext =
  createContext<FilterFieldsConfigContextValue>(defaultContextValue)

export const useFilterFieldsConfig = () => {
  return useContext(FilterFieldsConfigContext)
}
